
import { defineComponent } from 'vue';
import { FEATURE_FLAGS } from '@white-label-configuration/constants';
export default defineComponent({
  name: 'BTicketWrap',

  props: {
    isBundleProduct: {
      type: Boolean,
      default: false,
    },
    isExtended: {
      type: Boolean,
      default: false,
    },
  },
  computed:{
    FEATURE_FLAGS(): typeof FEATURE_FLAGS {
      return FEATURE_FLAGS;
    }
  }
});
